<template>
  <div class="modal fade" id="viewAllAdvances" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- Modal header start -->
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="viewAllAdvancesLabel">
                  View All Advances
                </h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeAllBills"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                  <span class="fa-stack fa-2x fsm float-right">
                    <i class="far fa-circle fa-stack-2x"></i>
                    <i class="fas fa-external-link-alt fa-stack-1x"></i>
                  </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal header end -->

        <div class="modal-body">
          <!-- Modal body start -->
          <div class="container-fluid" v-if="activeService">
            <!-- <div class="row">
            <div class="col-12">-->
            <div class="row">
              <div class="col col-md-auto mb-3">
                <div class="row">
                  <span class="col col-md-auto mt-2 mr-2"
                    >Previous 6 months</span
                  >
                  <a
                    @click="showPrevSixMonths()"
                    role="button"
                    class="col-auto btn btn-hc mx-1"
                    data-target="#viewAllAdvances"
                    >&lt;&lt;</a
                  >
                  <a
                    @click="showNextSixMonths()"
                    role="button"
                    class="col-auto btn btn-hc mx-1"
                    :class="{ 'btn--disabled': disableButton }"
                    data-target="#viewAllAdvances"
                    >&gt;&gt;</a
                  >
                  <span class="col col-md-auto mt-2 ml-2">Next 6 months</span>
                </div>
              </div>
              <div class="col-md-5 col-lg-4 offset-lg-1">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <span class="d-inline">Choose time frame:</span>
                      <b-form-select
                        v-model="selectedYear"
                        :options="years"
                        class="form-control d-inline"
                        name="selection"
                        required
                        @change="updateShownRange"
                      ></b-form-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </div>
              </div>-->
            </div>

            <!-- HH Elec Example -->
            <div class="hh_section mt-2">
              <div class="row mt-3">
                <div class="col-lg-8 fwfont">
                  <!-- col 8 left section start -->

                  <template>
                    <div class="h-100" v-if="shouldShowAdvances">
                      <div class="row">
                        <div
                          class="col-12 col-md-6 col-xl-4 px-2 mt-3"
                          v-for="(month, index) in lastSixMonths"
                          :key="index"
                        >
                          <div class="border border-secondaryL h-100 p-3">
                            <half-hourly-advances-calander
                              v-if="activeService"
                              v-model="selectedDay"
                              v-bind="HhMeterPoint"
                              :month="month"
                              select
                              @input="showAdvances(selectedDay)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- col 8 left section close -->
                <div
                  id="advances_table_results_all"
                  class="col-lg-4 mt-3 no-pad"
                  v-if="shouldShowAdvances"
                >
                  <advances-table
                    v-if="activeService"
                    :selectedDate="selectedDay"
                  />
                </div>
              </div>
            </div>
            <!-- End of HH section -->
          </div>
        </div>
        <!-- modal body close -->
      </div>
    </div>
  </div>
</template>
<script>
import advancesMixin from "@/mixins/meterInfo/readings/advances.js";
import _filters from "@/mixins/filters.js";

import HalfHourlyAdvancesCalander from "../widgets/meterInfoTabs/meterPointSummary/components/HalfHourlyAdvancesCalander";
import advancesTable from "../widgets/meterInfoTabs/meterPointSummary/components/AdvancesView";

export default {
  mixins: [_filters, advancesMixin],
  components: {
    HalfHourlyAdvancesCalander,
    advancesTable,
  },
};
</script>

<style scoped>
.btn--disabled {
  background-color: rgb(220, 220, 200) !important;
  border-color: rgb(220, 220, 200) !important;
  box-shadow: inset 0 0 4px rgb(180, 180, 180);
}
</style>